// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar--gIBEc"};